// Generated from vision-replay/assets/synthetic/Etikett_Blanko_VEKTOR.pdf by SR26.
// Do not hand-tune these coordinates: the vector PDF is the structural source of truth.
export const VECTOR_TEMPLATE_SCHEMA_VERSION = 1 as const;
export const VECTOR_TEMPLATE_VERSION = "material-label-vector-template-v1" as const;
export const VECTOR_TEMPLATE_SOURCE_FILE = "Etikett_Blanko_VEKTOR.pdf" as const;
export const VECTOR_TEMPLATE_SOURCE_SHA256 = "e9e0b2fc6e5053557c7341088fc24e4c820e5bf2ea2316172253b5799fa0349b" as const;
export const VECTOR_TEMPLATE_CONTRACT_SHA256 = "b33c0ebfbee98f804b6aa229abb11e8e72d6f473030c82487c70a90df0f086a2" as const;

export const VECTOR_TEMPLATE_HORIZONTAL_LINES = Object.freeze([
  0.0,
  0.32142857,
  0.601069,
  1.0
] as const);
export const VECTOR_TEMPLATE_VERTICAL_LINES = Object.freeze([
  0.0,
  0.0942876,
  0.44778341,
  0.55194089,
  0.89633877,
  1.0
] as const);

export const VECTOR_TEMPLATE_OCR_REGIONS = Object.freeze({
  materialText: {
  "height": 0.12414966,
  "left": 0.00661667,
  "mode": "block",
  "source": "VECTOR_HEADER_AND_CELL_GEOMETRY",
  "top": 0.16812439,
  "width": 0.43455007
},
  materialType: {
  "height": 0.34062196,
  "left": 0.05183061,
  "mode": "line",
  "source": "VECTOR_HEADER_AND_CELL_GEOMETRY",
  "top": 0.63022352,
  "width": 0.38933613
},
  materialNumber: {
  "height": 0.26311953,
  "left": 0.71460079,
  "mode": "line",
  "source": "VECTOR_HEADER_AND_CELL_GEOMETRY",
  "top": 0.02915452,
  "width": 0.27878253
},
  storageAddress: {
  "height": 0.57774538,
  "left": 0.45043008,
  "mode": "four-subcells",
  "source": "VECTOR_GRID_GEOMETRY",
  "top": 0.01166181,
  "width": 0.09886414
},
} as const);

export const VECTOR_TEMPLATE_STORAGE_SUBCELL_ROIS = Object.freeze({
  "building": {
    "height": 0.18270165,
    "left": 0.45043008,
    "top": 0.01166181,
    "width": 0.09886414
  },
  "cabinet": {
    "height": 0.17492711,
    "left": 0.45043008,
    "top": 0.21768707,
    "width": 0.09886414
  },
  "compartment": {
    "height": 0.17346939,
    "left": 0.45043008,
    "top": 0.4159378,
    "width": 0.04670269
  },
  "subCompartment": {
    "height": 0.17346939,
    "left": 0.50242611,
    "top": 0.4159378,
    "width": 0.04686811
  }
} as const);

export const VECTOR_TEMPLATE_REFERENCE_ASSETS = Object.freeze([
  {
    "role": "EASY",
    "source_file": "9830279941.pdf",
    "source_sha256": "a495889b7b8dced23717750b3e0f4275295b2565ce251682a3d51e5381434635",
    "truth_role": "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN"
  },
  {
    "role": "UMLAUT_SPECIAL_CHARACTER",
    "source_file": "9830153128.pdf",
    "source_sha256": "99c32b7a7ac1908075736ff5debc0544f179129098d2a983f45c847ad8266eb7",
    "truth_role": "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN"
  },
  {
    "role": "COMPLEX_TYPE_MULTILINE",
    "source_file": "9830255802.pdf",
    "source_sha256": "5df00f56b48785dc7ba35b884e413f9f9ed3f1b0540f5c9242b7b6c1e6788265",
    "truth_role": "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN"
  },
  {
    "role": "SPECIAL_LONG_ORDER_NUMBER",
    "source_file": "9830286913.pdf",
    "source_sha256": "d001c944ea100f02cf7dc45da098609947c7a6e620d2e122949291af863d2502",
    "truth_role": "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN"
  },
  {
    "role": "DENSE_AUTO_FONT_SCALING",
    "source_file": "9830329994.pdf",
    "source_sha256": "78ac58f903d0cd73a9b6c5372e5ca1b4e2158c0b6c4eb2d50b6ebca6ff9f22ee",
    "truth_role": "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN"
  }
] as const);

export const VECTOR_TEMPLATE_TRUTH_RULES = Object.freeze({
  blankVector: "AUTHORITATIVE_STRUCTURAL_SOURCE",
  filledDemo: "FILLED_LAYOUT_TYPOGRAPHY_REFERENCE_NOT_TRUTH",
  realFilledReferences: "REFERENCE_RENDER_ONLY_NOT_GT_GS_TRAIN",
  measureUnit: "IGNORED_FOR_RECOGNITION_TRUTH",
} as const);
